import React from "react"
import animations from "./animations"

export default function Defs() {
  const { loop } = animations

  return (
    <defs>
      {/* FLOOR GLOW */}
      <radialGradient
        id="floor-glow"
        cx="300.0531"
        cy="-3174.2085"
        r="310.1413"
        gradientTransform="matrix(0.7669 0 0 -0.3867 -5.1107 -792.5264)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.66" style={{ stopColor: "#4FC3F6", stopOpacity: 1 }} />
        <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: 0 }} />
      </radialGradient>

      {/* BEVEL GLOW */}
      <radialGradient
        id="bevel-glow"
        cx={225}
        cy="93.9021"
        r="128.8938"
        gradientTransform="matrix(1 0 0 -0.5249 0 414.3507)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7887" style={{ stopColor: "#4FC3F6" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </radialGradient>

      {/* INNER GLOW */}
      <radialGradient
        id="inner-glow"
        cx={225}
        cy="84.6359"
        r="123.0978"
        gradientTransform="matrix(1 0 0 -0.5184 0 410.4852)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="5.000000e-02" style={{ stopColor: "#4FC3F6" }} />
        <stop
          offset="0.5"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.8" }}
        />
        <stop
          offset="0.75"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.33" }}
        />
        <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: "0.3" }} />
      </radialGradient>

      {/* REAR PLATE TOP */}
      <radialGradient
        id="rear-plate-top"
        cx="224.1788"
        cy="73.2963"
        r="72.5116"
        gradientTransform="matrix(1 0 0 -0.477 0 358.6379)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7949" style={{ stopColor: "#324F80" }} />
        <stop offset="0.9532" style={{ stopColor: "#17253B" }} />
      </radialGradient>

      {/* FRONT PLATE TOP */}
      <radialGradient
        id="front-plate-top"
        cx="225.5581"
        cy="175.9099"
        r="90.7893"
        gradientTransform="matrix(1 0 0 -0.6293 0 496.1512)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.8507" style={{ stopColor: "#324F80" }} />
        <stop offset={1} style={{ stopColor: "#17253B" }} />
      </radialGradient>

      {/* LEFT PLATE TOP */}
      <radialGradient
        id="left-plate-top"
        cx="132.637"
        cy="404.3422"
        r="29.0191"
        gradientTransform="matrix(-0.9997 2.243622e-02 -2.404028e-02 -1.0712 254.622 793.9791)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7728" style={{ stopColor: "#324F80" }} />
        <stop offset={1} style={{ stopColor: "#17253B" }} />
      </radialGradient>

      {/* RIGHT PLATE TOP */}
      <radialGradient
        id="right-plate-top"
        cx="344.9423"
        cy="415.8177"
        r="29.0191"
        gradientTransform="matrix(0.9997 2.243622e-02 2.404028e-02 -1.0712 -17.1233 801.5084)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7728" style={{ stopColor: "#324F80" }} />
        <stop offset={1} style={{ stopColor: "#17253B" }} />
      </radialGradient>

      {/* FRONT PLATE BEVEL */}
      <linearGradient
        id="front-plate-bevel"
        gradientUnits="userSpaceOnUse"
        x1="225.1"
        y1="309.5099"
        x2="225.1"
        y2="291.5099"
        gradientTransform="matrix(1 0 0 -1 0 752.2198)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>

      {/* RIGHT PLATE BEVEL */}
      <linearGradient
        id="right-plate-bevel"
        gradientUnits="userSpaceOnUse"
        x1="363.545"
        y1="383.2184"
        x2="378.5779"
        y2="381.6359"
        gradientTransform="matrix(1 0 0 -1 0 752.2198)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>

      {/* LEFT PLATE BEVEL */}
      <linearGradient
        id="left-plate-bevel"
        gradientUnits="userSpaceOnUse"
        x1="151.1328"
        y1="383.2626"
        x2="166.1658"
        y2="381.6801"
        gradientTransform="matrix(-1 0 0 -1 237.5833 752.2198)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>

      {/* CEILING SIDE PLATES */}
      <linearGradient
        id="ceiling-side-plate"
        x1="100%"
        y1="100%"
        x2="100%"
        y2="0"
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} style={{ stopColor: "#283F66" }} />
        <stop offset={0.75} style={{ stopColor: "#111C2C" }} />
      </linearGradient>

      {/* CEILING BEVEL */}
      <radialGradient
        id="ceiling-bevel"
        cx="224.0995"
        cy="-11.481"
        r="300.0894"
        gradientTransform="matrix(1 0 0 0.2444 0 -8.675)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.6117" style={{ stopColor: "#111C2C" }} />
        <stop offset="0.8883" style={{ stopColor: "#17253B" }} />
      </radialGradient>

      {/* CEILING FRONT PLATE */}
      <linearGradient
        id="ceiling-front-plate"
        gradientUnits="userSpaceOnUse"
        x1="225.1021"
        y1="980.402"
        x2="225.1021"
        y2="998.6537"
        gradientTransform="matrix(1 0 0 -1 0 1024.5802)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>

      {/* CEILING FRONT PLATE BEVEL */}
      <radialGradient
        id="ceiling-front-plate-bevel"
        cx="225.5666"
        cy="1415.4739"
        r="92.0591"
        gradientTransform="matrix(1 0 0 -0.6293 0 992.9856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.8507" style={{ stopColor: "#324F80" }} />
        <stop offset={1} style={{ stopColor: "#17253B" }} />
      </radialGradient>

      {/* CEILING GLOW */}
      <radialGradient
        id="ceiling-glow"
        cx="226.5824"
        cy="671.8199"
        r="131.8311"
        gradientTransform="matrix(1 0 0 -0.6102 0 445.1461)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.296" style={{ stopColor: "#4FC3F6" }} />
        <stop
          offset="0.7989"
          style={{ stopColor: "#0D1824", stopOpacity: 0 }}
        />
      </radialGradient>

      {/* LIGHT RAYS */}
      <linearGradient
        id="ceiling-light-rays"
        gradientUnits="userSpaceOnUse"
        x1={225}
        y1="482.1949"
        x2={225}
        y2="675.5137"
        gradientTransform="matrix(1 0 0 -1 0 678.5802)"
      >
        <stop offset="0.33" style={{ stopColor: "#0D1824", stopOpacity: 0 }} />
        <stop offset={1} style={{ stopColor: "#4FC3F5" }} />
      </linearGradient>

      <linearGradient
        id="light-rays"
        gradientUnits="userSpaceOnUse"
        x1={225}
        y1="752.2198"
        x2={225}
        y2="321.4099"
        gradientTransform="matrix(1 0 0 -1 0 752.2198)"
      >
        <stop offset="0.33" style={{ stopColor: "#0D1824", stopOpacity: 0 }} />
        <stop offset={1} style={{ stopColor: "#4FC3F5" }} />
      </linearGradient>

      {/* TOWER FLOOR PLANE */}
      <linearGradient
        id="tower-floor-plane"
        x1="50%"
        y1="100%"
        x2="50%"
        y2="0"
        gradientUnits="objectBoundingBox"
      >
        <stop
          {...loop.towerFloorGlow}
          offset={0}
          style={{ stopColor: "#4FC3F6" }}
        />
        <stop offset={1} style={{ stopColor: "#4FC3F6", stopOpacity: 0 }} />
      </linearGradient>

      {/* TOWER RIGHT PLANE */}
      <linearGradient
        id="tower-right-plane"
        x1="50%"
        y1="100%"
        x2="50%"
        y2="0"
        gradientUnits="objectBoundingBox"
      >
        <stop
          {...loop.towerRightGlow}
          offset={0}
          style={{ stopColor: "#4FC3F6" }}
        />

        <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: 0 }} />
      </linearGradient>

      {/* TOWER LEFT PLANE */}
      <linearGradient
        id="tower-left-plane"
        x1="50%"
        y1="100%"
        x2="100%"
        y2="0"
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} style={{ stopColor: "#4FC3F6", stopOpacity: 0.5 }} />
        <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: 0 }} />
      </linearGradient>

      {/* TOWER ROOF PLANE */}
      <linearGradient
        id="tower-roof-plane"
        x1="50%"
        y1="0"
        x2="50%"
        y2="100%"
        gradientUnits="objectBoundingBox"
      >
        <stop
          {...loop.towerRoofGlow}
          offset={0}
          style={{ stopColor: "#4FC3F6" }}
        />
        <stop offset={1} style={{ stopColor: "#4FC3F6", stopOpacity: 0 }} />
      </linearGradient>

      {/* DRONE BODY PLANE */}
      <linearGradient
        id="drone-body"
        gradientUnits="userSpaceOnUse"
        x1="225.6"
        y1={432}
        x2="225.6"
        y2="448.1"
        gradientTransform="matrix(1 0 0 -1 0 552)"
      >
        <stop offset={0} style={{ stopColor: "#4FC3F6", stopOpacity: 0.1 }} />
        <stop offset={1} style={{ stopColor: "#4FC3F6", stopOpacity: 0.66 }} />
      </linearGradient>

      {/* DRONE BLADE 1 */}
      <linearGradient
        id="drone-blade-1"
        gradientUnits="userSpaceOnUse"
        x1="220.0672"
        y1="444.3201"
        x2="226.0343"
        y2="447.8608"
        gradientTransform="matrix(1 0 0 -1 0 552)"
      >
        <stop offset={0} style={{ stopColor: "#4FC3F6" }} />
        <stop offset={1} style={{ stopColor: "#4FC3F6", stopOpacity: 0 }} />
      </linearGradient>

      {/* DRONE BLADE 2 */}
      <linearGradient
        id="drone-blade-2"
        gradientUnits="userSpaceOnUse"
        x1="230.2906"
        y1="454.0228"
        x2="225.7301"
        y2="450.234"
        gradientTransform="matrix(1 0 0 -1 0 552)"
      >
        <stop offset={0} style={{ stopColor: "#4FC3F6" }} />
        <stop offset={1} style={{ stopColor: "#4FC3F6", stopOpacity: 0 }} />
      </linearGradient>
    </defs>
  )
}
